import {COUNT_TYPE_OPTIONS} from 'common/report/funnels/models/constants';
import {CountType} from 'common/report/funnels/models/types';

export function getCountTypeSections(countType: CountType, showSessions: boolean) {
  const options = COUNT_TYPE_OPTIONS.filter(({value}) => (value === CountType.Session ? showSessions : true));

  return [
    {
      items: options.map((option) => ({
        ...option,
        isSelected: option.value === countType,
      })),
    },
  ];
}
